import { normalizeD1ToastVariant } from '@brands/Components/ToastContainer/D1Toast';
import { AlertColor } from '@mui/material';
import { useCallback, useRef } from 'react';
import { Id, toast } from 'react-toastify';

interface SnackbarState {
  isOpen: boolean;
  message: string;
  type: AlertColor;
}

export const useSnackbar = (): any => {
  const toastIdsRef = useRef<Id[]>([]);

  const snackbar: SnackbarState = {
    isOpen: false,
    message: '',
    type: 'success',
  };

  // Raised in the same react-toastify container as every other toast, so they
  // share one stack instead of two libraries drawing over each other at the
  // same anchor. Reusing the message as the toastId drops a repeat that is
  // still on screen.
  const showSnackbar = useCallback((message: string, type: AlertColor = 'success') => {
    const variant = normalizeD1ToastVariant(type);
    const id = toast(message, {
      autoClose: 5000,
      toastId: `${variant}:${message}`,
      type: variant,
    });

    toastIdsRef.current = [...toastIdsRef.current, id];
  }, []);

  const closeSnackbar = useCallback(() => {
    toastIdsRef.current.forEach((id) => toast.dismiss(id));
    toastIdsRef.current = [];
  }, []);

  return {
    snackbar,
    showSnackbar,
    closeSnackbar,
  };
};
